// Copyright 2026. WebPros International GmbH. All rights reserved.

import styled from 'styled-components';

export const PageContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;
